export { default } from "./ClickOutsideDetector";
